const USERS_QUERY_KEY = 'users';

const USER_QUERY_KEY = (name: string): string[] => [USERS_QUERY_KEY, name];

export { USERS_QUERY_KEY, USER_QUERY_KEY };
